var React = require('react');

function MobileNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M70 7.75465L62.7546 0.5093L62.1413 1.1226L68.3397 7.32095L6.95807e-06 7.32095L7.0339e-06 8.18829L68.3398 8.18829L62.1413 14.3867L62.7546 15L70 7.75465Z","fill":"#202020"}));
}

MobileNext.defaultProps = {"width":"70","height":"15","viewBox":"0 0 70 15","fill":"none"};

module.exports = MobileNext;

MobileNext.default = MobileNext;
